import ResearchitemScreen from './containers/researchitemScreen'

export {default as ResearchitemScreenLayout} from './components/researchitemScreenLayout'

export default ResearchitemScreen
